import * as React from "react";
import {FastField} from "formik";
import {FormGroup} from "../../../../../../../../libs/components/libs/form/group/index";
import {Button} from "../../../../../../../../libs/components/libs/button/index";
import {RotateLoader} from "../../../../../../../../libs/components/libs/loaders/rotate/index";
import {Switch} from "../../../../../../../../libs/components/libs/form/switch/Switch";
import {Input} from "../../../../../../../../libs/components/libs/form/input/index";
import {MobxComponent} from "../../../../../../../mobx/components/index";
import {inject, observer} from "mobx-react";
import {RestaurantForm} from "../../../../../../../mobx/components/restaurant-form";
import {UI} from "../../../../../../../core/ui";

interface Props {}
interface State {}
type FormValues = RestaurantSchema["settings"]["business"]["age_verification"];

@inject("store") @observer
export class SettingsFormAgeVerification extends MobxComponent<Props, State> {

  initialValues: FormValues;

  constructor(props: Props) {
    super(props);
    this.state = {};
    const r = this.injected.store.restaurant!;
    this.initialValues = r.settings.business.age_verification;
  }

  render() {
    return (
      <RestaurantForm<FormValues>
        submit={async (r, values) => {
          r.settings.business.age_verification = values;
          const update = { $set: { "settings.business.age_verification": values } };
          return { r, update };
        }}
        validators={{}}
        initialValues={this.initialValues}
        onSuccess={() => {}}
        onError={() => UI.notification.error("An error occurred")}
        onSuccessMessage="Settings Updated"
        onErrorMessage="">
        {({ form, error }) => {
          const { isSubmitting, setFieldValue, setFieldTouched } = form;
          return (
            <div className="p-4">

              <FormGroup
                title="Enabled"
                help="Age verification allows customers to upload their legal documents. You can use this to manually verify the identity and age of the customer. Useful for selling age restricted products">
                <FastField
                  name="age_verification.enabled"
                  render={({ field }: any) => (
                    <Switch
                      id="age_verification.enabled"
                      checked={field.value}
                      onChange={(e) => setFieldValue("age_verification.enabled", e.target.checked)}/>
                  )}
                />
              </FormGroup>

              <FormGroup
                title="Minimum Age (Years)"
                help="The minimum age required is displayed to the customer during the age verification process and on your online store">
                <FastField
                  name="age_verification.min_age"
                  render={({ field }: any) => (
                    <Input type="number" step="1" min="0" max="200" required={true} {...field}/>
                  )}
                />
              </FormGroup>

              <FormGroup
                title="Estimated Wait Time (Hours)"
                help="Give your customers an estimated approval time. This will be shown to customers during the age verification process">
                <FastField
                  name="age_verification.estimated_wait_time"
                  render={({ field }: any) => (
                    <Input type="number" step="1" min="0" max="200" required={true} {...field}/>
                  )}
                />
              </FormGroup>

              <FormGroup
                title="Store Popup Notification"
                help="Notify your customers as soon as they load your online store that the items you sell are age restricted">
                <FastField
                  name="age_verification.store_popup_notification"
                  render={({ field }: any) => (
                    <Switch
                      id="age_verification.store_popup_notification"
                      checked={field.value}
                      onChange={(e) => setFieldValue("age_verification.store_popup_notification", e.target.checked)}/>
                  )}
                />
              </FormGroup>

              {error && <FormGroup error={error}/>}

              <Button full={true} color="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting && <RotateLoader size={2} color="white"/>}
                {!isSubmitting && "Save"}
              </Button>

            </div>
          );
        }}
      </RestaurantForm>
    );
  }

}
